import { Card, CardContent, CardHeader, CardTitle, CardDescription } from "@/components/ui/card";
import { Button } from "@/components/ui/button";
import { SrIcon } from "@/components/ui/SrIcon";
import { cn } from "@/lib/utils";
import { useRecurringAutosend, useToggleRecurringAutosend } from "@/hooks/use-recurring-autosend";

/**
 * VIB-1293: superadmin-bryter for automatisk utsending fra fakturamotoren.
 * Av by default. Når PÅ sendes fakturaer for avtaler med auto_send=true
 * automatisk til kunde; ellers lages kun UTKAST i PowerOffice.
 */
export function RecurringAutosendPanel() {
  const { data: enabled = false, isLoading } = useRecurringAutosend();
  const toggle = useToggleRecurringAutosend();

  return (
    <Card>
      <CardHeader>
        <CardTitle className="flex items-center gap-2 text-lg">
          <SrIcon name="send" className="h-4 w-4 text-muted-foreground" />
          Automatisk fakturautsending
        </CardTitle>
        <CardDescription>
          Global bryter for fakturamotoren (løpende avtaler). Når PÅ sendes fakturaer for avtaler med
          auto-send automatisk til kunde. Når AV lages kun utkast i PowerOffice som må sendes manuelt.
        </CardDescription>
      </CardHeader>
      <CardContent className="space-y-3">
        <div className="flex items-center justify-between rounded border px-3 py-2.5">
          <div className="flex items-center gap-2">
            <span
              className={cn(
                "inline-flex items-center px-2 py-0.5 rounded-md text-xs font-medium",
                enabled ? "bg-success/10 text-success" : "bg-muted text-muted-foreground",
              )}
            >
              {isLoading ? "…" : enabled ? "PÅ" : "AV"}
            </span>
            <span className="text-sm text-muted-foreground">
              {enabled ? "Fakturaer sendes automatisk" : "Kun utkast (ingen automatisk utsending)"}
            </span>
          </div>
          <Button
            variant={enabled ? "outline" : "default"}
            size="sm"
            disabled={isLoading || toggle.isPending}
            onClick={() => toggle.mutate(!enabled)}
          >
            {enabled ? "Skru AV" : "Skru PÅ"}
          </Button>
        </div>
        <div className="rounded border border-amber-200 bg-amber-50 px-3 py-2 text-xs text-amber-800 flex items-start gap-2">
          <SrIcon name="alert-triangle" className="w-3.5 h-3.5 mt-0.5 shrink-0" />
          <span>
            Auto-send treffer ekte kunder. Verifiser mot PowerOffice demo-tenant på staging før den skrus på i
            produksjon. Hver endring logges med hvem som gjorde den.
          </span>
        </div>
      </CardContent>
    </Card>
  );
}
